import React, { useMemo } from "react";
import "./DispositionDetailModal.scss";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { JsonView, collapseAllNested } from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";
import OwLabel from "@components/shared/OwLabel/OwLabel";

type Props = {
    closeModalFn: () => void;
    responseJson: string | null;
};

export const DispositionDetailModal: React.FC<Props> = (props) => {
    const { responseJson } = props;

    const parsedData = useMemo(() => {
        if (!responseJson) return null;
        try {
            return JSON.parse(responseJson);
        } catch {
            return null;
        }
    }, [responseJson]);

    return (
        <div className="DispositionDetailModal p-2">
            <div className="modal-header d-flex justify-content-between align-items-center">
                <OwTitle leftIconName="fas fa-file-export" title="disposition_details" tag="h3" defaultMargins={false} />
                <OwButton className="btn-danger" centerIconClass="fas fa-times" fn={props.closeModalFn} />
            </div>

            <div className="modal-body">
                <div>
                    <OwLabel title="disposition_status_note" />
                </div>
                {parsedData ? (
                    <JsonView data={parsedData} shouldExpandNode={collapseAllNested} />
                ) : (
                    <pre className="text-muted">{responseJson || "No disposition data available."}</pre>
                )}
            </div>

            <div className="modal-footer d-flex justify-content-end align-items-center">
                <OwButton className="btn-danger" title="close" fn={props.closeModalFn} />
            </div>
        </div>
    );
};
